import defaultLocale from './default';
export default defaultLocale;
//# sourceMappingURL=en_US.js.map
